import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import BlogFullWidthSectionOne from '../../components/blog-components/BlogFullWidthSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const BlogFullWidthOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Blog Full Width 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Blog Full Width 1"
        />
        
        <BlogFullWidthSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default BlogFullWidthOne;